<template>
  <small-subheader>
    <span class="title font-weight-medium">General Terms and Conditions of Use</span>
  </small-subheader>
</template>

<script>
import SmallSubheader from '@/components/layout/SmallSubheader'

export default {
  components: { SmallSubheader }
}
</script>
